"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _hotspot = require("../../hotspot.defaultConfigs");

var _custom = require("./custom.styles");

var _custom2 = _interopRequireWildcard(require("./custom.helpers"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/**
 * Custom hotspot has 2 types of hover
 *  1. When hover effect include a background-image
 *    - Will Inject a separate div as hover div
 *    - Will Format hover div background CSS style
 *    - The goal is to preload image to reduce the very short blank moment on first hover
 *  2. When hover effect doesn't include a background-image
 *    - Hotspot will be only 1 div
 *    - Hover effect is made through CSS hover
 */


var Custom = function Custom(_ref) {
  var config = _ref.config,
      iconPosition = _ref.iconPosition,
      onClick = _ref.onClick,
      previewHoverState = _ref.previewHoverState,
      disableHover = _ref.disableHover,
      name = _ref.name;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      ccsCSSHover = _useState4[0],
      setCSSHover = _useState4[1];

  var customConfig = config || _hotspot.custom;

  var hoverStyle = customConfig.hoverStyle,
      defaultStyle = _objectWithoutProperties(customConfig, ["hoverStyle"]);

  var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  (0, _react.useEffect)(function () {
    if (!hoverStyle || !hoverStyle.backgroundImage) {
      setCSSHover(true);
    }
  }, []); // Adjust transition to exclude opacity from global transition style
  // Adjust opacity ease to minimize glitch

  var _defaultStyle$transit = defaultStyle.transition,
      transition = _defaultStyle$transit === void 0 ? ' all 200ms ease' : _defaultStyle$transit;
  var defaultTransition = transition.split(' ').filter(function (item) {
    return item !== "";
  });
  var formattedTransition = (0, _custom2.getTransition)(defaultTransition[1], defaultTransition[2]);
  var backgroundPosition = defaultStyle.backgroundPosition,
      backgroundRepeat = defaultStyle.backgroundRepeat,
      backgroundSize = defaultStyle.backgroundSize;
  var formattedHoverStyle = ccsCSSHover ? undefined : _objectSpread({
    backgroundPosition: backgroundPosition,
    backgroundRepeat: backgroundRepeat,
    backgroundSize: backgroundSize
  }, hoverStyle);

  var mouseoverHandler = function mouseoverHandler() {
    setFocus(true);
  };

  var mouseoutHandler = function mouseoutHandler() {
    setFocus(false);
  };

  var ariaLabel = "".concat(name, " hotspot");
  return _react.default.createElement(_custom.ClickableAreaStyled, {
    onClick: onClick,
    hoverStyle: ccsCSSHover ? (0, _custom2.default)(hoverStyle) : undefined,
    onFocus: ccsCSSHover ? undefined : mouseoverHandler,
    onBlur: ccsCSSHover ? undefined : mouseoutHandler,
    onMouseEnter: ccsCSSHover ? undefined : mouseoverHandler,
    onMouseLeave: ccsCSSHover ? undefined : mouseoutHandler,
    previewHoverState: previewHoverState,
    disableHover: disableHover,
    "aria-label": ariaLabel
  }, !ccsCSSHover && iconPosition && _react.default.createElement(_custom.CustomStyled, {
    hoverEffect: true,
    config: (0, _custom2.default)(formattedHoverStyle),
    iconPosition: iconPosition,
    transition: ccsCSSHover ? undefined : formattedTransition,
    className: focus ? 'show' : 'hide',
    isChrome: true
  }), iconPosition && _react.default.createElement(_custom.CustomStyled, {
    config: (0, _custom2.default)(defaultStyle),
    iconPosition: iconPosition,
    className: focus ? 'hide' : 'show',
    transition: ccsCSSHover ? undefined : formattedTransition,
    isChrome: true
  }));
};

var _default = Custom;
exports.default = _default;